<script lang="ts" setup>
import { computed } from 'vue';

import RatingStars from '@/components/pdp/reviews/RatingStars.vue';
import { pluralizeBy } from '@/filters/pluralize';
import { ApprovedReviews } from '@/lib/reviews';

const props = defineProps<{ reviews: ApprovedReviews }>();

const showRating = computed(() => props.reviews.averageRating >= 3);
const quantity = computed(() => props.reviews.totalRatings);
const displayText = computed(() => pluralizeBy('Rating', quantity.value));
</script>

<template>
  <div v-if="showRating" class="flex items-center" data-test="inline-rating">
    <RatingStars :rating="reviews.averageRating" />
    <span
      v-if="quantity"
      class="flex items-center ml-2 text-sm text-neutral-500 md:text-nuts-cyan-600"
      data-test="inline-review-show"
    >
      <span class="sr-only">{{ quantity }} {{ displayText }}</span>
      <span aria-hidden="true" class="font-bold">({{ reviews.averageRating.toFixed(1) }})</span>
      <span
        aria-hidden="true"
        class="ml-1 font-semibold"
        :class="{ 'hidden ml-1 md:block md:visible': !reviews.totalRatings }"
      >
        {{ quantity.toLocaleString() }}
      </span>
      <span aria-hidden="true" class="hidden ml-1 md:block md:visible">{{ displayText }}</span>
    </span>
  </div>
</template>
